<template>
    <base-dialog :loading="loading" :value="dialog" :width="420"
        :title="`${editMode ? $t('common.edit') : $t('common.add')} ${$t('common.group')}`"
        @input="val => { if (!val) hide() }" @close="hide">
        <kimsa-text-field :placeholder="$t('common.name')" @change="name = $event" :value="name" force-value />

        <template v-slot:footer>
            <dialog-actions :confirm-label="editMode ? $t('common.edit') : $t('common.add')" :disabled="!valid"
                :loading="loading" @cancel="hide" @confirm="save" />
        </template>
    </base-dialog>
</template>

<script>
import KimsaTextField from "@/components/common/inputs/KimsaTextField";

import {db, FieldValue} from "@/utils/Firebase";
import BaseDialog from "@/components/common/BaseDialog";
import DialogActions from "@/components/common/DialogActions";
export default {
    name: "CreateGroupStudentsDialog",
    components: {KimsaTextField, BaseDialog, DialogActions},
    props: {
        isSecondDialog: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            dialog: false,
            name: '',
            loading: false,
            group: null,
            editMode: false,
        }
    },
    computed: {
        valid(vm = this) {
            return vm.name.length >= 3
        }
    },
    methods: {
        show() {
            const vm = this
            vm.dialog = true
        },
        hide() {
            const vm = this
            vm.dialog = false
            vm.reset()
        },
        reset() {
            const vm = this
            vm.name = ''
            vm.group = null
            vm.editMode = false
        },
        loadGroup(group) {
            const vm = this
            vm.editMode = true
            vm.name = group.name
            vm.group = group
            vm.show()
        },
        async save() {
            const vm = this
            await vm.withLoading(async () => {
                if(vm.editMode) {
                    await db.collection('groups').doc(vm.group.id).update({
                        name: vm.name,
                    })
                    vm.toast(vm.$t('common.group_edited'))
                } else {
                    await db.collection('groups').add({
                        coachId: vm.currentUser.uid,
                        name: vm.name,
                        students: [],
                    })

                    await db.collection('users').doc(vm.currentUser.uid).update({
                        groupsQuantity: FieldValue.increment(1),
                    })

                    vm.toast(vm.$t('common.group_added'))
                }

                vm.hide()
            })
        }
    },

}
</script>

